var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Breakpoints } from '../helpers/breakpoint';
import { styled } from '../theme-provider';
import { Text, TextTag, TokenTextAppearance } from '../text';
import { Richtext, createTagOverride } from '../richtext';
import { getCommonProps } from '../helpers/common-props';
const maxTextWidth = '850px';
const maxMediaHeightMobile = '64px';
const maxMediaHeight = '146px';
// only allow markdown to make certain text parts "strong"
const markdownOverrides = {
    h1: createTagOverride(React.Fragment),
    h2: createTagOverride(React.Fragment),
    h3: createTagOverride(React.Fragment),
    h4: createTagOverride(React.Fragment),
    p: createTagOverride(React.Fragment),
    span: createTagOverride(React.Fragment),
    div: createTagOverride(React.Fragment),
    strong: createTagOverride(Text, { tag: TextTag.strong, bold: true }),
    a: createTagOverride(React.Fragment),
    ul: createTagOverride(React.Fragment),
    ol: createTagOverride(React.Fragment),
    li: createTagOverride(React.Fragment),
};
const TeaserContentCtasWrapper = styled.div.withConfig({ displayName: "TeaserContentCtasWrapper", componentId: "sc-3tognv" }) `display:flex;flex-direction:column;row-gap:${({ theme }) => theme.size.static150};margin-top:${({ theme }) => theme.size.static250};align-items:flex-start;@media (min-width: ${Breakpoints.b560}px){flex-direction:row;flex-wrap:wrap;column-gap:${({ theme }) => theme.size.static250};align-items:center;}`;
const TeaserLayout = styled.div.withConfig({ displayName: "TeaserLayout", componentId: "sc-10a9nav" }) `align-items:flex-start;background-color:${({ theme }) => theme.colors.background.tertiary};display:flex;flex-direction:column-reverse;gap:${({ theme }) => theme.size.static150};padding:${({ theme }) => `${theme.size.static350}`};@media (min-width: ${Breakpoints.b560}px){align-items:center;column-gap:${({ theme }) => `${theme.size.static400}`};flex-direction:row;justify-content:space-between;}`;
const TeaserContentWrapper = styled.div.withConfig({ displayName: "TeaserContentWrapper", componentId: "sc-11b1fyo" }) `display:flex;flex-direction:column;gap:${({ theme }) => theme.size.static150};max-width:${maxTextWidth};`;
const TeaserMediaWrapper = styled.div.withConfig({ displayName: "TeaserMediaWrapper", componentId: "sc-l6be0d" }) `display:flex;flex-shrink:0;align-items:flex-start;& > *{max-height:${maxMediaHeightMobile};object-fit:contain;width:auto;max-width:100%;}@media (min-width: ${Breakpoints.b560}px){align-items:center;& > *{max-height:${maxMediaHeight};}}`;
export const Teaser = (_a) => {
    var { ctas, media, headline, text } = _a, rest = __rest(_a, ["ctas", "media", "headline", "text"]);
    return (React.createElement(TeaserLayout, Object.assign({}, getCommonProps(rest)),
        React.createElement(TeaserContentWrapper, null,
            headline && (React.createElement(Text, { appearance: TokenTextAppearance.headline300, staticSize: true },
                React.createElement(Richtext, { markdown: headline, overrides: markdownOverrides }))),
            text && (React.createElement(Text, { appearance: TokenTextAppearance.copy200, staticSize: true }, text)),
            ctas && React.createElement(TeaserContentCtasWrapper, null, ctas)),
        media && React.createElement(TeaserMediaWrapper, null, media)));
};
